<template>
  <Flex direction="column">
    <BaseCheckbox
      v-model="isEnabled"
      :label="$t('marketing.discounts.apply_to_services')"
      v-test="'discount-services-toggle'"
    />
    <BaseGroupedCheckboxList
      v-if="isEnabled"
      v-model="listValue"
      :data="listData"
      :label="$t('resource.all_treatments')"
      :expandedHeader="!listValue.length"
      v-test="'discount-services-list'"
    />
  </Flex>
</template>

<script
  setup
  lang="ts"
>
import { useServicesStore } from '@/stores/services';

const listValue = defineModel<number[]>('modelValue', { required: true });
const isEnabled = ref(!!listValue.value.length);

watch(isEnabled, (value) => {
  if (!value) {
    listValue.value = [];
  }
});

const listData = computed(() => {
  const { categoriesWithServices } = useServicesStore();
  const _categoriesWithServices = categoriesWithServices.filter(
    (category) => category.services.length,
  );
  return _categoriesWithServices.length
    ? _categoriesWithServices.map((category) => ({
        label: category.name,
        color: category.color,
        items: category.services.map((service) => ({
          label: service.name,
          id: service.id,
        })),
      }))
    : [];
});
</script>
